import React from "react";
import { Grid } from "sprint-common-web";

import { CloudAssetDetailsSections } from "./CloudAssetDetailsSections";
import { CloudAssetDetailsPageHeader } from "./header/CloudAssetDetailsPageHeader";

export const CloudAssetDetailsPage = (): JSX.Element => {
    return (
        <Grid>
            <CloudAssetDetailsPageHeader />
            <CloudAssetDetailsSections />
        </Grid>
    );
};
